// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hXVWa","icon":"styles_icon__2qxSZ"};